var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.ruleForm.siteId
          ? _vm.$t("COMMON_EDIT")
          : _vm.$t("COMMON_ADD_ITEM"),
        visible: "",
        width: "40%",
      },
      on: { close: _vm.onCancel },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-position": "left",
            "label-width": "140px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SITE_TABLE_HEADER_SITE_NAME"),
                prop: "siteName",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "100",
                  placeholder: _vm.$t("SITE_TABLE_HEADER_SITE_NAME"),
                },
                model: {
                  value: _vm.ruleForm.siteName,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "siteName", $$v)
                  },
                  expression: "ruleForm.siteName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SITE_LABEL_SITE_OWNER"),
                prop: "siteOwner",
              },
            },
            [
              _c("select-ad", {
                ref: "ownertAdd",
                staticClass: "wl-m-select",
                attrs: {
                  collapseTags: false,
                  showAdd: false,
                  filter: _vm.adFilter,
                  onChanage: _vm.onsiteOwnerChange,
                  api: _vm.selectFromAD,
                },
                model: {
                  value: _vm.ruleForm.siteOwner,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "siteOwner", $$v)
                  },
                  expression: "ruleForm.siteOwner",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SITE_LABEL_SITE_MANGER"),
                prop: "siteManager",
              },
            },
            [
              _c("select-ad", {
                ref: "mangerAdd",
                staticClass: "wl-m-select",
                attrs: {
                  collapseTags: false,
                  showAdd: false,
                  filter: _vm.adFilter,
                  onChanage: _vm.onsiteMangerChange,
                  api: _vm.selectFromAD,
                },
                model: {
                  value: _vm.ruleForm.siteManager,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "siteManager", $$v)
                  },
                  expression: "ruleForm.siteManager",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SITE_TABLE_HEADER_SITE_ADMIN"),
                prop: "userList",
              },
            },
            [
              _c("select-ad", {
                ref: "selectAdd",
                staticClass: "wl-m-select",
                attrs: {
                  collapseTags: false,
                  showAdd: false,
                  filter: _vm.adFilter,
                  onChanage: _vm.onsiteAdminChange,
                  api: _vm.selectFromAD,
                },
                model: {
                  value: _vm.ruleForm.userList,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "userList", $$v)
                  },
                  expression: "ruleForm.userList",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SITE_TABLE_HEADER_ENGAGEMENT_CODE"),
                prop: "engagementMasterCode",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "50",
                  placeholder: _vm.$t("SITE_TABLE_HEADER_ENGAGEMENT_CODE"),
                },
                model: {
                  value: _vm.ruleForm.engagementMasterCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "engagementMasterCode", $$v)
                  },
                  expression: "ruleForm.engagementMasterCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("form_code_type"), prop: "codeType" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("form_code_type") },
                  model: {
                    value: _vm.ruleForm.codeType,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "codeType", $$v)
                    },
                    expression: "ruleForm.codeType",
                  },
                },
                _vm._l(_vm.codeTypeOptions, function (v, k) {
                  return _c("el-option", {
                    key: k,
                    attrs: { value: v.value, label: v.label },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "siteFlag",
                "label-width": _vm.i18N === "en" ? "410px" : "300px",
              },
            },
            [
              _c("template", { slot: "label" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("SITE_ADD_NEW_ITEM_LLP_TIP")) +
                    "\n      "
                ),
              ]),
              _c("el-switch", {
                attrs: {
                  disabled: !!_vm.ruleForm.siteId,
                  "active-color": "#3879eb",
                  "inactive-color": "#a9acaf",
                },
                on: {
                  change: function ($event) {
                    return _vm.changeSiteFlag($event, 1)
                  },
                },
                model: {
                  value: _vm.ruleForm.siteFlag,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "siteFlag", $$v)
                  },
                  expression: "ruleForm.siteFlag",
                },
              }),
            ],
            2
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "siteFlag2",
                label: _vm.$t("SITE_ADD_NEW_ITEM_OVERSEA"),
                "label-width": _vm.i18N === "en" ? "410px" : "300px",
              },
            },
            [
              _c("el-switch", {
                attrs: {
                  disabled: !!_vm.ruleForm.siteId,
                  "active-color": "#3879eb",
                  "inactive-color": "#a9acaf",
                },
                on: {
                  change: function ($event) {
                    return _vm.changeSiteFlag($event, 2)
                  },
                },
                model: {
                  value: _vm.ruleForm.siteFlag2,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "siteFlag2", $$v)
                  },
                  expression: "ruleForm.siteFlag2",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "downloadAble",
                "label-width": _vm.i18N === "en" ? "410px" : "300px",
              },
            },
            [
              _c("template", { slot: "label" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("DOWNLOAD_AUTH")) + "\n      "
                ),
              ]),
              _c("el-switch", {
                attrs: {
                  "active-color": "#3879eb",
                  "inactive-color": "#a9acaf",
                },
                on: { change: _vm.authChange },
                model: {
                  value: _vm.ruleForm.downloadAble,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "downloadAble", $$v)
                  },
                  expression: "ruleForm.downloadAble",
                },
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "cancel-btn", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary", loading: _vm.editLoading },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }